var _StyledToggle;
import React, { useState } from 'react';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import { styled, useTheme } from '@mui/material/styles';
import SovosTooltip from '../../../sovos-tooltip';
import SovosMenuItem from '../../../sovos-menu-item';
import { hasNestedLinks, isLinkSelected } from '../../../internals/navigation/linkUtils';
import { navigationLinksPropTypes } from '../../../internals/prop-types/navigationLinks';
import SectionHeader from './SectionHeader';
import { collapsedWidthFactor } from '../../../themes/sovos-sizes';
import HEADER from '../../constants/header';
import { spacingToNumber } from '../../../internals/utils';
import BaseLink from './BaseLink';
import BaseSelectedIndicator from './BaseSelectedInidicator';
import BaseIcon from './BaseIcon';
import BaseToggle from './BaseToggle';
const StyledLink = styled(BaseLink)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    margin: "".concat(spacing(0.25), " ").concat(spacing(0.5), " 0 ").concat(spacing(0.5)),
    paddingLeft: spacing(0.25),
    paddingRight: spacing(0.25)
  };
});
const StyledSelectedIndicator = styled(BaseSelectedIndicator)(_ref2 => {
  let {
    theme: {
      spacing
    }
  } = _ref2;
  return {
    left: spacing(0.5),
    marginRight: spacing(0.5),
    position: 'absolute',
    width: spacing(0.5)
  };
});
const StyledIcon = styled(BaseIcon)(_ref3 => {
  let {
    theme: {
      spacing
    }
  } = _ref3;
  return {
    marginLeft: spacing(1.75)
  };
});
const StyledToggle = styled(BaseToggle)(_ref4 => {
  let {
    theme: {
      spacing
    }
  } = _ref4;
  return {
    position: 'absolute',
    right: "-".concat(spacing(0.25))
  };
});
const nullLink = {
  anchorEl: null,
  link: null
};
const NavigationLinksMinimal = _ref5 => {
  let {
    selectedLink,
    onLinkClick,
    links
  } = _ref5;
  const {
    spacing
  } = useTheme();
  const [expandedMenu, setExpandedMenu] = useState(nullLink);
  const closeMenu = () => setExpandedMenu(nullLink);
  const handleLinkClick = (event, link) => {
    const expand = hasNestedLinks(link);
    if (expand) {
      setExpandedMenu({
        anchorEl: event.currentTarget,
        link: link.id || link.label
      });
    } else {
      onLinkClick(link, expand);
      closeMenu();
    }
  };
  const renderNestedLinkArrow = link => {
    if (!hasNestedLinks(link)) return null;
    return _StyledToggle || (_StyledToggle = /*#__PURE__*/React.createElement(StyledToggle, null));
  };
  const renderNestedList = link => {
    const menuLeft = spacingToNumber(spacing(collapsedWidthFactor)) + spacingToNumber(spacing(0.5));
    if (hasNestedLinks(link)) {
      return /*#__PURE__*/React.createElement(Menu, {
        anchorEl: expandedMenu.anchorEl,
        anchorOrigin: {
          horizontal: menuLeft,
          vertical: 0
        },
        open: isLinkSelected(link, expandedMenu.link),
        onClose: closeMenu,
        transformOrigin: {
          horizontal: 'left',
          vertical: 'top'
        }
      }, link === null || link === void 0 ? void 0 : link.nestedLinks.map(nestedLink => /*#__PURE__*/React.createElement(SovosMenuItem, {
        disabled: link.disabled,
        onClick: link.disabled ? null : e => handleLinkClick(e, nestedLink),
        key: nestedLink.label
      }, /*#__PURE__*/React.createElement(ListItemText, {
        primary: nestedLink.label
      }))));
    }
    return null;
  };
  function shouldShowSelectedIndicator(link) {
    if (isLinkSelected(link, selectedLink)) {
      return true;
    }
    if (hasNestedLinks(link)) {
      return !!link.nestedLinks.find(nl => isLinkSelected(nl, selectedLink));
    }
    return false;
  }
  function renderLinkItem(link) {
    const isSelected = shouldShowSelectedIndicator(link);
    if (link.type === HEADER) {
      return /*#__PURE__*/React.createElement(SectionHeader, {
        key: link.label
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: link.label
    }, /*#__PURE__*/React.createElement(SovosTooltip, {
      title: link.label
    }, /*#__PURE__*/React.createElement(StyledLink, {
      isDisabled: link.disabled,
      isSelected: isSelected,
      onClick: link.disabled ? null : e => handleLinkClick(e, link)
    }, isSelected && /*#__PURE__*/React.createElement(StyledSelectedIndicator, {
      element: "i",
      isSelected: isSelected
    }), link.icon && /*#__PURE__*/React.createElement(StyledIcon, {
      element: link.icon
    }), renderNestedLinkArrow(link))), renderNestedList(link));
  }
  return /*#__PURE__*/React.createElement(List, {
    className: "sovosNavigationLinks"
  }, links.map(link => renderLinkItem(link)));
};
NavigationLinksMinimal.propTypes = navigationLinksPropTypes;
export default NavigationLinksMinimal;